import React, { useState, useEffect, useCallback } from "react";
import { ThemeProvider } from "@mui/material/styles";
import Table_theme from "../Themes/TableTheme";
import { LocalizationProvider, DatePicker } from "@mui/x-date-pickers";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import { parse, format } from "date-fns";
import FormThemes from "../Themes/FormThemes";
import { ReactComponent as DeleteIcon } from "../Icons/Delete.svg";
import { ReactComponent as SettingsIcon } from "../Icons/Settings.svg";
import EditOutlinedIcon from "@mui/icons-material/EditOutlined";
import { formatDateLocal, formatDateLocal_TF } from "../utils/dateUtils";
import CloseIcon from "@mui/icons-material/Close";
import MainLayout from "../Themes/MainLayout";
import MuiAlert from "@mui/material/Alert";
import {
  Tooltip,
  TextField,
  Pagination,
  Grid,
  MenuItem,
  CssBaseline,
} from "@mui/material";
import {
  Box,
  Button,
  Container,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
} from "@mui/material";

import {
  IconButton,
  Alert,
  Paper,
  Table,
  TableBody,
  TableCell,
  InputProps,
  TableContainer,
  TableHead,
  TableRow,
  Snackbar,
  Popover,
  InputAdornment,
  Switch,
  Typography,
} from "@mui/material";
import { Add, Flag, FilterList, Search } from "@mui/icons-material";
import { hasPermission } from "../utils/auth";
import { hr } from "date-fns/locale";
import { useCurrentUser } from "../utils/useCurrentUser";

const BASE_URL = process.env.REACT_APP_API_BASE_URL;

const displayColumns = {
  cl_name: "Client Name",
  proj_name: "Project Name",
  description: "Description",
  start_date: "Start Date",
  planned_end_date: "Planned End Date",
  actual_enddate: "Actual End Date",
  projectstatus: "Project Status",
  progresspercentage: "Progress %",
  risklevel: "Risk Level",
  budgetamount: "Budget Amount",
  currencycode: "Currency Code",
  billingtype: "Billing Type",
  invoicingcycle: "Invoicing Cycle",
  manager_name: "Project Manager",
  lead_name: "Project Lead",
  HR_name: "HR Manager",
  approval_level_required: "Approval Level Required",
  clientpoc: "Client POC",
  clientpocemail: "Client POC Email",
  deliverymodel: "Delivery Model",
  location: "Location",
  timezone: "Timezone",
};

const formFields = [
  "cl_id",
  "proj_name",
  "description",
  "start_date",
  "planned_end_date",
  "actual_enddate",
  "projectstatus",
  "progresspercentage",
  "risklevel",
  "budgetamount",
  "currencycode",
  "billingtype",
  "invoicingcycle",
  "approval_level_required",
  "technicalleadid",
  "projectmanagerid",
  "hrid",
  "clientpoc",
  "clientpocemail",
  "deliverymodel",
  "location",
  "timezone",
];
const initialFormState = {
  cl_name: "",
  proj_name: "",
  description: "",
  start_date: "",
  planned_end_date: "",
  actual_enddate: "",
  projectstatus: "",
  progresspercentage: "",
  risklevel: "",
  budgetamount: "",
  currencycode: "",
  billingtype: "",
  invoicingcycle: "",
  projectmanagerid: "",
  technicalleadid: "",
  hrid: "",
  approval_level_required: "",
  clientpoc: "",
  clientpocemail: "",
  deliverymodel: "",
  location: "",
  timezone: "",
};

const ClientProjects = () => {
  const [approvalLevel, setApprovalLevel] = useState([]);
  const [projectStatus, setProjectStatus] = useState([]);
  const [projectName, setProjectName] = useState([]);
  const [riskLevel, setRiskLevel] = useState([]);
  const [currencyCodes, setCurrencyCodes] = useState([]);
  const [invoiceCycle, setInvoiceCycle] = useState([]);
  const [deliveryModel, setDeliveryModel] = useState([]);
  const [billingTypes, setBillingTypes] = useState([]);
  const [timezones, setTimezones] = useState([]);
  const [countries, setCountries] = useState([]);
  const [formSubmitted, setFormSubmitted] = useState(false);
  const [employeeNameMap, setEmployeeNameMap] = useState({});
  const [dialogOpen, setDialogOpen] = useState(false);
  const [editMode, setEditMode] = useState(false);
  const [formState, setFormState] = useState({ initialFormState });
  const [managers, setManagers] = useState([]);
  const [tls, setTLs] = useState([]);
  const [hrd, setHRs] = useState([]);
  const [selectedManager, setSelectedManager] = useState("");
  const [selectedTL, setSelectedTL] = useState("");
  const [selectedHR, setSelectedHR] = useState("");
  const [clients, setClients] = useState([]);
  const [fieldErrors, setFieldErrors] = useState({});
  const [isEditing, setIsEditing] = useState(false);
  const [snackbarSeverity, setSnackbarSeverity] = useState("success");
  const [clProject, setclProject] = useState([]);
  const [filters, setFilters] = useState({ deleteFlag: "ACTIVE" });
  const [anchorEls, setAnchorEls] = useState({});
  const [statusOptions, setStatusOptions] = useState([]);
  const [successMessage, setSuccessMessage] = useState("");
  const [errorMessage, setErrorMessage] = useState("");
  const [errors, setErrors] = useState({});
  const [confirmOpen, setConfirmOpen] = useState(false);
  const [deleteId, setDeleteId] = useState(null);
  const [columnVisibility, setColumnVisibility] = useState(() => {
    const initial = {};
    Object.keys(displayColumns).forEach((f) => (initial[f] = true));
    return initial;
  });
  const [columnAnchorEl, setColumnAnchorEl] = useState(null);
  const [page, setPage] = useState(0);
  const [totalCount, setTotalCount] = useState(0);
  const [open, setOpen] = useState(false);
  const [editOpen, setEditOpen] = useState(false);
  const [snackbarMsg, setSnackbarMsg] = useState("");
  const [showSnackbar, setShowSnackbar] = useState(false);
  const [search, setSearch] = useState("");
  const { loading, userId, empId, boId, roles, hasPermission } =
    useCurrentUser();
  const visibleColumns = Object.keys(displayColumns).filter(
    (field) => columnVisibility[field]
  );

  const rowsPerPage = 10;
  const fetchClientProjects = useCallback(async () => {
    try {
      const params = new URLSearchParams({
        page: page + 1,
        limit: rowsPerPage,
        ...filters,
        search: search.trim(),
        boId,
        empId,
        roles,
      });

      const res = await fetch(
        `${BASE_URL}/clientprojects/paginated?${params.toString()}`
      );
      const data = await res.json();
      setclProject(data.data || []);
      setTotalCount(data.total);
    } catch (err) {
      console.error("Error fetching client projects:", err);
    }
  }, [page, filters, search, rowsPerPage]);

  useEffect(() => {
    fetchClientProjects();
  }, [fetchClientProjects]);

  useEffect(() => {
    setPage(0);
  }, [search, filters, boId]);

  useEffect(() => {
    const fetchClients = async () => {
      try {
        const res = await fetch(`${BASE_URL}/clients/${boId}`);
        const data = await res.json();
        setClients(data);
      } catch (err) {
        console.error("Error fetching clients:", err);
      }
    };

    fetchClients();
  }, []);

useEffect(() => {
  const fetchEmployees = async () => {
    try {
      const res = await fetch(
        `${BASE_URL}/clientprojects/get-managers-tls/${boId}`
      );
      const data = await res.json();

      const map = {};
      data.forEach((emp) => {
        map[emp.employee_id] = emp.employee_name;
      });

      setEmployeeNameMap(map);

      const normalizeRoles = (roles) => {
        if (!roles) return [];
        const str = Array.isArray(roles) ? roles.join(', ') : roles;
        return str.split(',').map((r) => r.trim().toLowerCase());
      };

      setManagers(
        data.filter((emp) => {
          const roles = normalizeRoles(emp.roles);
          return ['project manager', 'pm', 'pms', 'project managers'].some((role) =>
            roles.includes(role)
          );
        })
      );

      setTLs(
        data.filter((emp) => {
          const roles = normalizeRoles(emp.roles);
          return ['technical lead', 'tl', 'tls', 'technical leads'].some((role) =>
            roles.includes(role)
          );
        })
      );

      setHRs(
        data.filter((emp) => {
          const roles = normalizeRoles(emp.roles);
          return ['human resource', 'hr', 'hrs', 'human resources'].some((role) =>
            roles.includes(role)
          );
        })
      );
    } catch (err) {
      console.error("Error fetching employees:", err);
    }
  };

  fetchEmployees();
}, [boId]);

  useEffect(() => {
    const fetchCountries = async () => {
      try {
        const response = await fetch(`${BASE_URL}/commonVariables/countries`);

        if (!response.ok) {
          throw new Error(`HTTP error! status: ${response.status}`);
        }

        const countries = await response.json();

        if (!Array.isArray(countries)) {
          throw new Error("Invalid dropdown data format received");
        }

        setCountries(countries); //  assuming you have state like: const [countries, setCountries] = useState([]);
      } catch (error) {
        console.error("Error fetching countries:", error);
        setSnackbarMsg(error.message || "Failed to load dropdown data.");
        setShowSnackbar(true);
      }
    };

    fetchCountries();
  }, []);

  // --- fetch once on page load ---
  const fetchDropdown = async (type, setter) => {
    try {
      const response = await fetch(`${BASE_URL}/commonVariables/${type}`);
      if (!response.ok)
        throw new Error(`HTTP error! status: ${response.status}`);
      const data = await response.json();

      if (Array.isArray(data)) {
        setter(data); // directly set the array
      } else {
        throw new Error("Invalid dropdown data format received");
      }
    } catch (error) {
      console.error(`Error fetching ${type}:`, error);
      setSnackbarMsg(error.message || `Failed to load ${type}.`);
      setShowSnackbar(true);
    }
  };

  useEffect(() => {
    fetchDropdown("RISK_LEVEL", setRiskLevel);
    fetchDropdown("PROJECT_STATUS", setProjectStatus);
    fetchDropdown("BILLING_TYPE", setBillingTypes);
    fetchDropdown("CURRENCY_CODE", setCurrencyCodes);
    fetchDropdown("TIMEZONE", setTimezones);
    fetchDropdown("approval_level_required", setApprovalLevel);
    fetchDropdown("INVOICING_CYCLE", setInvoiceCycle);
    fetchDropdown("DELIVERY_MODEL", setDeliveryModel);

  }, []);

  useEffect(() => {
    const fetchStatusFlags = async () => {
      try {
        const res = await fetch(`${BASE_URL}/commonVariables/statusFlag`);
        const data = await res.json();
        setStatusOptions(data); // [{ code: "ACTIVE", label: "Active" }, ...]
      } catch (err) {
        console.error("Failed to fetch employee status flags:", err);
      }
    };

    fetchStatusFlags();
  }, []);

  const handleEdit = (row) => {
    setFormState({
      ...row,
      start_date: row.start_date ? formatDateLocal_TF(row.start_date) : "",
      planned_end_date: row.planned_end_date
        ? formatDateLocal_TF(row.planned_end_date)
        : "",
      actual_enddate: row.actual_enddate
        ? formatDateLocal_TF(row.actual_enddate)
        : "",
    });
    setEditMode(true);
    setDialogOpen(true);
    setSelectedManager(row.projectmanagerid || "");
    setSelectedTL(row.technicalleadid || "");
    setSelectedHR(row.hrid || "");
  };

  const handleAdd = () => {
    setOpen(true);
    setEditMode(false);
    setFormState(initialFormState);
    setErrors({}); // clear validation errors
    setDialogOpen(true);
  };

  const renderField = (
    field,
    formState,
    setFormState,
    clients = [],
    managers = [],
    tls = [],
    hrd = [],
    countries = [],
    formSubmitted,
    fieldErrors,
    timezones = []
  ) => {
    const isDateField = [
      "start_date",
      "planned_end_date",
      "actual_enddate",
    ].includes(field);
    const isNumberField = ["progresspercentage", "budgetamount"].includes(
      field
    );

    const handleChange = (e) => {
      const { name, value } = e.target;
      setFormState((prev) => {
        const newLevel = name === "approval_level_required" ? Number(value) : Number(prev.approval_level_required);
        return {
          ...prev,
          [name]: name === "approval_level_required" || name === "progresspercentage"
            ? Number(value)
            : value,
          ...(name === "approval_level_required" && {
            projectmanagerid: Number(value) >= 2 ? prev.projectmanagerid : "",
            hrid: Number(value) === 3 ? prev.hrid : "",
          }),
        };
      });
      // Inline validation
      setErrors((prev) => {
        const newErrors = { ...prev };

        if (name === "progresspercentage") {
          const numValue = Number(value);
          if (isNaN(numValue)) {
            newErrors[name] = "Progress must be a number";
          } else if (numValue < 0 || numValue > 100) {
            newErrors[name] = "Progress must be between 0 and 100";
          } else {
            newErrors[name] = ""; // clear error if valid
          }
        } else {
          // clear other field errors
          newErrors[name] = "";
        }

        return newErrors;
      });
    };
    const commonSx = {
      "& .MuiInputBase-root": {
        fontSize: "12px",
        fontFamily: "Arial",
        minHeight: 30,
        borderRadius: "9px",
        backgroundColor: "#fafafa",
        color: "#292727ff",
      },
      "& .MuiInputBase-input": {
        fontSize: "12px",
        fontFamily: "Arial",
        padding: "8.5px 14px",
      },
      "& .MuiInputLabel-root": {
        fontSize: "12px",
        fontFamily: "Arial",
      },
      "& .MuiSelect-select": {
        fontSize: "12px",
        padding: "8.5px 14px",
      },
      mt: 0.5,
      mb: 0,
      width: "200px",
    };

    if (isDateField) {
      return (
        <LocalizationProvider dateAdapter={AdapterDateFns}>
          <DatePicker
            label={displayColumns[field] || field}
            value={
              formState[field]
                ? parse(formState[field], "yyyy-MM-dd", new Date())
                : null
            }
            onChange={(newValue) =>
              setFormState((prev) => ({
                ...prev,
                [field]: newValue ? format(newValue, "yyyy-MM-dd") : "",
              }))
            }
            format="MM/dd/yyyy"
            slotProps={{
              textField: {
                required: true,
                size: "small",
                name: field,
                placeholder: "MM/DD/YYYY",
                InputLabelProps: { shrink: true },
                InputProps: {
                  sx: {
                    paddingTop: "2px",
                    paddingBottom: "2px",
                    fontSize: "12px",
                    height: 35,
                    "& .MuiInputLabel-root": {
                      fontSize: "12px",
                      color: "#000000",
                    },
                    backgroundColor: "#fafafa",
                  },
                },
                error: formSubmitted && !!fieldErrors?.[field],
                helperText: formSubmitted ? fieldErrors?.[field] : "",
                sx: commonSx,
              },
            }}
          />
        </LocalizationProvider>
      );
    }
    // Client dropdown
    if (field === "cl_id") {
      return (
        <TextField
          select
          label="Client *"
          name="cl_id"
          value={formState.cl_id || ""}
          onChange={handleChange}
          size="small"
          InputLabelProps={{ shrink: true }}
          error={Boolean(errors.cl_id)}
          helperText={errors.cl_id || ""}
          sx={commonSx}
        >
          {clients.map((client) => (
            <MenuItem
              key={client.cl_id}
              value={client.cl_id}
              sx={{ fontSize: "12px" }}
            >
              {client.cl_name}
            </MenuItem>
          ))}
        </TextField>
      );
    }
    if (field === "progresspercentage") {
      return (
        <TextField
          label="Progress %"
          name="progresspercentage"
          type="number"
          value={formState.progresspercentage || ""}
          onChange={handleChange}
          size="small"
          InputLabelProps={{ shrink: true }}
          error={Boolean(errors.progresspercentage)}
          helperText={errors.progresspercentage || ""}
          sx={commonSx}
          inputProps={{ min: 0, max: 100 }} // restrict user input
        />
      );
    }
    // Manager dropdown - Required for Level 2 and Level 3
    if (field === "projectmanagerid") {
      const approvalLevel = Number(formState.approval_level_required);
      const isDisabled = approvalLevel < 2;
      return (
        <TextField
          select
          label="Project Manager *"
          name="projectmanagerid"
          value={formState.projectmanagerid || ""}
          onChange={handleChange}
          size="small"
          InputLabelProps={{ shrink: true }}
          sx={commonSx}
          disabled={isDisabled}
          error={Boolean(errors.projectmanagerid)}
         
          SelectProps={{
            renderValue: (val) => {
              const found = managers.find((m) => m.employee_id === val);
              return found ? found.employee_name : val;
            },
          }}
        >
          {managers.map((mgr) => (
            <MenuItem key={mgr.employee_id} value={mgr.employee_id} sx={{ fontSize: "12px" }}>
              <Box>
                <Typography sx={{ fontSize: "12px", fontWeight: 500 }}>{mgr.employee_name}</Typography>
                <Typography sx={{ fontSize: "11px", color: "text.secondary" }}>{mgr.employee_id}</Typography>
              </Box>
            </MenuItem>
          ))}
        </TextField>
      );
    }

    // TL dropdown - Required for all levels (1, 2, 3)
    if (field === "technicalleadid") {
      const approvalLevel = Number(formState.approval_level_required);
      const isDisabled = approvalLevel < 1;
      return (
        <TextField
          select
          label="Technical Lead *"
          name="technicalleadid"
          value={formState.technicalleadid || ""}
          onChange={handleChange}
          size="small"
          InputLabelProps={{ shrink: true }}
          sx={commonSx}
          disabled={isDisabled}
          error={Boolean(errors.technicalleadid)}

          SelectProps={{
            renderValue: (val) => {
              const found = tls.find((t) => t.employee_id === val);
              return found ? found.employee_name : val;
            },
          }}
        >
          {tls.map((tl) => (
            <MenuItem key={tl.employee_id} value={tl.employee_id} sx={{ fontSize: "12px" }}>
              <Box>
                <Typography sx={{ fontSize: "12px", fontWeight: 500 }}>{tl.employee_name}</Typography>
                <Typography sx={{ fontSize: "11px", color: "text.secondary" }}>{tl.employee_id}</Typography>
              </Box>
            </MenuItem>
          ))}
        </TextField>
      );
    }

    // HR dropdown - Required for Level 3 only
    if (field === "hrid") {
      const approvalLevel = Number(formState.approval_level_required);
      const isDisabled = approvalLevel !== 3;
      return (
        <TextField
          select
          label="HR Manager *"
          name="hrid"
          value={formState.hrid || ""}
          onChange={handleChange}
          size="small"
          InputLabelProps={{ shrink: true }}
          sx={commonSx}
          disabled={isDisabled}
          error={Boolean(errors.hrid)}
         
          SelectProps={{
            renderValue: (val) => {
              const found = hrd.find((h) => h.employee_id === val);
              return found ? found.employee_name : val;
            },
          }}
        >
          {hrd.map((hr) => (
            <MenuItem key={hr.employee_id} value={hr.employee_id} sx={{ fontSize: "12px" }}>
              <Box>
                <Typography sx={{ fontSize: "12px", fontWeight: 500 }}>{hr.employee_name}</Typography>
                <Typography sx={{ fontSize: "11px", color: "text.secondary" }}>{hr.employee_id}</Typography>
              </Box>
            </MenuItem>
          ))}
        </TextField>
      );
    }
    if (field === "approval_level_required") {
      return (
        <TextField
          select
          required
          label="Approval Level Required"
          name="approval_level_required"
          value={formState.approval_level_required ?? ""}
          onChange={handleChange}
          size="small"
          InputLabelProps={{ shrink: true }}
          sx={commonSx}
          error={Boolean(errors.approval_level_required)}
          helperText={errors.approval_level_required || ""}
        >
          {approvalLevel.map((al) => (
            <MenuItem
              key={al.variable_code}
              value={al.variable_code.replace("LEVEL", "")} // converts LEVEL1 → "1"
              sx={{ fontSize: "12px" }}
            >
              {al.variable_value} {/* shows "Level 1", "Level 2", etc. */}
            </MenuItem>
          ))}
        </TextField>
      );
    }

    // Location dropdown
    if (field === "location") {
      return (
        <TextField
          select
          label="Location"
          name="location"
          value={formState.location || ""}
          onChange={handleChange}
          size="small"
          InputLabelProps={{ shrink: true }}
          sx={commonSx}
        >
          {countries.map((loc) => (
            <MenuItem
              key={loc.country_id}
              value={loc.country_name}
              sx={{ fontSize: "12px" }}
            >
              {loc.country_name}
            </MenuItem>
          ))}
        </TextField>
      );
    }
    // Timezone dropdown
    if (field === "timezone") {
      const tzList = Array.isArray(timezones) ? timezones : [];
      return (
        <TextField
          select
          label="Timezone"
          name="timezone"
          value={formState.timezone || ""}
          onChange={handleChange}
          size="small"
          fullWidth
          InputLabelProps={{ shrink: true }}
          sx={commonSx}
        >
          {tzList.map((tz) => (
            <MenuItem
              key={tz.variable_code}
              value={tz.variable_code}
              sx={{ fontSize: "12px" }}
            >
              {tz.variable_code}
            </MenuItem>
          ))}
        </TextField>
      );
    }
    // project status dropdown
    if (field === "projectstatus") {
      return (
        <TextField
          select
          label="Project Status"
          name="projectstatus"
          value={formState.projectstatus || ""}
          onChange={handleChange}
          size="small"
          InputLabelProps={{ shrink: true }}
          sx={commonSx}
        >
          {projectStatus.map((ps) => (
            <MenuItem
              key={ps.variable_code}
              value={ps.variable_value}
              sx={{ fontSize: "12px" }}
            >
              {ps.variable_value}
            </MenuItem>
          ))}
        </TextField>
      );
    }
    // currency code dropdown
    if (field === "currencycode") {
      return (
        <TextField
          select
          label="Currency Code"
          name="currencycode"
          value={formState.currencycode || ""}
          onChange={handleChange}
          size="small"
          InputLabelProps={{ shrink: true }}
          sx={commonSx}
        >
          {currencyCodes.map((cc) => (
            <MenuItem
              key={cc.variable_code}
              value={cc.variable_code}
              sx={{ fontSize: "12px" }}
            >
              {cc.variable_code}
            </MenuItem>
          ))}
        </TextField>
      );
    }
    // Risk level dropdown
    if (field === "risklevel") {
      return (
        <TextField
          select
          label="Risk Level"
          name="risklevel"
          value={formState.risklevel || ""}
          onChange={handleChange}
          size="small"
          InputLabelProps={{ shrink: true }}
          sx={commonSx}
        >
          {riskLevel.map((rl) => (
            <MenuItem
              key={rl.variable_code}
              value={rl.variable_value}
              sx={{ fontSize: "12px" }}
            >
              {rl.variable_value}
            </MenuItem>
          ))}
        </TextField>
      );
    }
    // billing type dropdown
    if (field === "billingtype") {
      return (
        <TextField
          select
          label="Billing Type"
          name="billingtype"
          value={formState.billingtype || ""}
          onChange={handleChange}
          size="small"
          InputLabelProps={{ shrink: true }}
          sx={commonSx}
        >
          {billingTypes.map((bt) => (
            <MenuItem
              key={bt.variable_code}
              value={bt.variable_value}
              sx={{ fontSize: "12px" }}
            >
              {bt.variable_value}
            </MenuItem>
          ))}
        </TextField>
      );
    }
    // Invoicing Cycle type dropdown
    if (field === "invoicingcycle") {
      return (
        <TextField
          select
          label="Invoicing Cycle"
          name="invoicingcycle"
          value={formState.invoicingcycle || ""}
          onChange={handleChange}
          size="small"
          InputLabelProps={{ shrink: true }}
          sx={commonSx}
        >
          {invoiceCycle.map((bt) => (
            <MenuItem
              key={bt.variable_code}
              value={bt.variable_value}
              sx={{ fontSize: "12px" }}
            >
              {bt.variable_value}
            </MenuItem>
          ))}
        </TextField>
      );
    }
    // Deliver model Cycle type dropdown
    if (field === "deliverymodel") {
      return (
        <TextField
          select
          label="Delivery Model"
          name="deliverymodel"
          value={formState.deliverymodel || ""}
          onChange={handleChange}
          size="small"
          InputLabelProps={{ shrink: true }}
          sx={commonSx}
        >
          {deliveryModel.map((bt) => (
            <MenuItem
              key={bt.variable_code}
              value={bt.variable_value}
              sx={{ fontSize: "12px" }}
            >
              {bt.variable_value}
            </MenuItem>
          ))}
        </TextField>
      );
    }
    // Normal text/date/number fields
    return (
      <TextField
        key={field}
        label={
          field === "proj_name"
            ? `${displayColumns[field] || field} *` // Add asterisk only for project name
            : displayColumns[field] || field
        }
        name={field}
        type={isDateField ? "date" : isNumberField ? "number" : "text"}
        value={
          isDateField
            ? (formState[field] || "").split("T")[0]
            : formState[field] || ""
        }
        onChange={handleChange}
        margin="dense"
        InputLabelProps={{ shrink: true }}
        size="small"
        sx={commonSx}
        error={Boolean(errors[field])}
        helperText={errors[field] || ""}
      />
    );
  };

  const handleSubmit = async () => {
    try {
      const { start_date, planned_end_date, actual_enddate, approval_level_required } = formState;

      // --- Validate required fields based on approval level ---
      const requiredFields = {
        cl_id: "Client is required",
        proj_name: "Project Name is required",
        approval_level_required: "Approval Level is required",
      };
      
      // Conditional required fields based on approval level
      const approvalLevel = Number(approval_level_required);
      
      // Level 1: TL required
      // Level 2: TL + PM required
      // Level 3: TL + PM + HR required
      if (approvalLevel >= 1) {
        requiredFields.technicalleadid = "Technical Lead is required";
      }
      if (approvalLevel >= 2) {
        requiredFields.projectmanagerid = "Project Manager is required";
      }
      if (approvalLevel === 3) {
        requiredFields.hrid = "HR Manager is required";
      }

      let newErrors = {};
      for (const [field, message] of Object.entries(requiredFields)) {
        if (!formState[field]) {
          newErrors[field] = message;
        }
      }
      // --- Progress percentage validation ---
      if (formState.progresspercentage != null) {
        const progress = Number(formState.progresspercentage);
        if (isNaN(progress)) {
          newErrors.progresspercentage = "Progress must be a number";
        } else if (progress < 0 || progress > 100) {
          newErrors.progresspercentage = "Progress must be between 0 and 100";
        }
      }
      // Validate client_poc email only if filled
      if (
        formState.clientpocemail &&
        formState.clientpocemail.trim() !== ""
      ) {
        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        if (!emailRegex.test(formState.clientpocemail)) {
          newErrors.clientpocemail = "Invalid email format";
        }
      }
      if (Object.keys(newErrors).length > 0) {
        setErrors(newErrors);
        return; // stop submit until fixed
      } else {
        setErrors({}); // clear errors if valid
      }

      // Validate planned dates
      if (start_date && planned_end_date) {
        const start = new Date(start_date);
        const end = new Date(planned_end_date);
        if (end < start) {
          setSnackbarMsg("Planned End date must be after Start date");
          setSnackbarSeverity("error");
          setShowSnackbar(true);
          return;
        }
      }

      // Validate actual dates
      if (start_date && actual_enddate) {
        const start = new Date(start_date);
        const end = new Date(actual_enddate);
        if (end < start) {
          setSnackbarMsg("Actual End date must be after Start date");
          setSnackbarSeverity("error");
          setShowSnackbar(true);
          return;
        }
      }

      const payload = {
        ...formState,
        bo_id: boId,
        modified_by: empId,
        ...(editMode ? {} : { created_by: empId }),
      };

      const url = editMode
        ? `${BASE_URL}/clientprojects/update/${formState.cl_proj_id}`
        : `${BASE_URL}/clientprojects/add`;

      const method = editMode ? "PUT" : "POST";

      const res = await fetch(url, {
        method,
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(payload),
      });

      if (!res.ok) {
        const errData = await res.json();
        throw new Error(errData.error || "Failed to save project");
      }

      const result = await res.json();
      setDialogOpen(false);
      setOpen(false);
      setSuccessMessage(
        `${editMode ? "Record Updated" : "Record Added"} successfully!`
      );
      setTimeout(() => setSuccessMessage(""), 5000);
      fetchClientProjects();
    } catch (err) {
      console.error("Submit error:", err);
      // Since we used fetch, the error message is inside err.message
      if (err.message === "The Project already exists") {
        setSnackbarMsg("The Project already exists for the Client");
        setSnackbarSeverity("error");
        setShowSnackbar(true);
      } else {
        setSnackbarMsg(err.message || "Something went wrong");
        setSnackbarSeverity("error");
        setShowSnackbar(true);
      }
    }
  };

  const handleFilterIconClick = (field, event) => {
    setAnchorEls((prev) => ({ ...prev, [field]: event.currentTarget }));
  };

  const handleFilterClose = (field) => {
    setAnchorEls((prev) => ({ ...prev, [field]: null }));
  };

  const handleDelete = (cl_proj_id, proj_name) => {
    setDeleteId(cl_proj_id);
    setProjectName(proj_name);
    setConfirmOpen(true);
  };

  const confirmDelete = async () => {
    const bo_id = boId;
    const deleteUrl = `${BASE_URL}/clientprojects/delete/${deleteId}/${bo_id}`;

    try {
      const res = await fetch(deleteUrl, { method: "DELETE" });

      if (!res.ok) {
        const errorText = await res.text();
        console.error("Server returned error:", res.status, errorText);
        return;
      }

      const result = await res.json();
      setSuccessMessage("Record Deleted Successfully..");
      setTimeout(() => setSuccessMessage(""), 5000);
      fetchClientProjects();
    } catch (error) {
      setErrorMessage(error.message || "Something went wrong");
    } finally {
      setConfirmOpen(false);
      setDeleteId(null);
    }
  };

  const handleToggleFlag = async (cl_proj_id, currentFlag) => {
    try {
      const res = await fetch(
        `${BASE_URL}/clientprojects/toggle-flag/${cl_proj_id}/${boId}`,
        {
          method: "PUT",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({ currentFlag }),
        }
      );

      if (!res.ok) {
        const errorText = await res.text();
        console.error("Toggle flag error:", res.status, errorText);
        return;
      }

      const result = await res.json();
      setSuccessMessage("Toggle Flag updated Successfully..");
      setTimeout(() => setSuccessMessage(""), 5000);
      fetchClientProjects();
    } catch (error) {
      console.error("Toggle flag error:", error.message);
      setErrorMessage("Failed to update Flag.");
      setTimeout(() => setErrorMessage(""), 5000);
    }
  };

  return (
    <ThemeProvider theme={Table_theme}>
      <CssBaseline />
      <MainLayout>

        {successMessage && (
          <Alert severity="success" sx={{ mb: 2 }}>
            {successMessage}
          </Alert>
        )}
        {errorMessage && (
          <Alert severity="error" sx={{ mb: 2 }}>
            {errorMessage}
          </Alert>
        )}
        <Box display="flex" alignItems="center" mb={2} gap={1.5}>
          <IconButton onClick={(e) => setColumnAnchorEl(e.currentTarget)}>
            <SettingsIcon />
          </IconButton>
          <Popover
            open={Boolean(columnAnchorEl)}
            anchorEl={columnAnchorEl}
            onClose={() => setColumnAnchorEl(null)}
            anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
            transformOrigin={{ vertical: "top", horizontal: "left" }}
            PaperProps={{
              sx: {
                mt: 1,
                p: 1,
                width: 250,
                maxHeight: 300,
                overflowY: "auto",
                borderRadius: 2,
              },
            }}
          >
            {Object.keys(displayColumns).map((field) => (
              <MenuItem key={field} disableGutters sx={{ p: 0, mb: 1 }}>
                <Box
                  sx={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                    width: "100%",
                    border: "1px solid #ccc",
                    borderRadius: 1.5,
                    px: 2,
                    py: 1,
                    backgroundColor: "#fff",
                    gap: 1,
                  }}
                >
                  <Typography
                  sx={{
                      fontSize: "0.8rem",
                      color: "#333",
                      fontWeight: "bold",
                    }}
                  >
                    {displayColumns[field] || field}
                  </Typography>
                  <Box sx={{ flexShrink: 0 }}>
                    <Switch
                      size="small"
                      checked={columnVisibility[field]}
                      onChange={() =>
                        setColumnVisibility((prev) => ({
                          ...prev,
                          [field]: !prev[field],
                        }))
                      }
                      sx={{
                        "& .MuiSwitch-switchBase.Mui-checked": {
                          color: "#2DB0E4",
                        },
                        "& .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track":
                          {
                            backgroundColor: "#2DB0E4",
                          },
                      }}
                    />
                  </Box>
                </Box>
              </MenuItem>
            ))}
          </Popover>
          {hasPermission("Client Projects", "Edit") && (
            <Button
              variant="contained"
              size="small"
              onClick={handleAdd}
              sx={{
                fontWeight: "bold",
                borderRadius: "8px",
                px: 2.5,
                height: 36,
                backgroundColor: "#2DB0E4",
              }}
              startIcon={<Add />}
            >
              Add
            </Button>
          )}
          <TextField
            size="small"
            placeholder="Search..."
            value={search}
            onChange={(e) => setSearch(e.target.value)}
            sx={{
              width: 250,
              "& input": { fontSize: 14 }, // input + placeholder
              "& input::placeholder": { fontSize: 12 }, // placeholder only
            }}
            InputProps={{
              sx: {
                height: 36, // Reduce overall input height
                paddingRight: 0,
              },
              startAdornment: (
                <InputAdornment position="start">
                  <Search fontSize="small" />
                </InputAdornment>
              ),
            }}
          />
          {/* Status Dropdown */}
          <TextField
            select
            size="small"
            label="Status"
            value={filters.deleteFlag}
            onChange={(e) =>
              setFilters((prev) => ({ ...prev, deleteFlag: e.target.value }))
            }
            sx={{
              width: 200,
              // Make height match the 36px of the search field
              "& .MuiInputBase-root": {
                height: 36,
              },

              // Fix vertical alignment of text
              "& .MuiSelect-select": {
                display: "flex",
                alignItems: "center",
                fontSize: 12,
                padding: "0 14px",
              },

              // Label font size
              "& .MuiInputLabel-root": { fontSize: "14px" },
            }}
            SelectProps={{
              MenuProps: {
                PaperProps: {
                  sx: {
                    "& .MuiMenuItem-root": {
                      fontSize: "14px",
                      minHeight: "32px",
                    },
                  },
                },
              },
            }}
          >
            <MenuItem value="All">All</MenuItem>
            {statusOptions.map((opt) => (
              <MenuItem key={opt.code} value={opt.code}>
                {opt.label}
              </MenuItem>
            ))}
          </TextField>
        </Box>
        <Box
          sx={{ width: "100%", overflowX: "auto", px: 0, py: 2, mt: "-10px" }}
        >
          <TableContainer component={Paper}>
            <Table size="small">
              <TableHead>
                <TableRow>
                  <TableCell
                    sx={{
                      whiteSpace: "nowrap",
                      textAlign: "center",
                      fontWeight: "bold",
                    }}
                  >
                    Actions
                  </TableCell>

                  {visibleColumns.map((field) => (
                    <TableCell
                      key={field}
                      sx={{
                        whiteSpace: "nowrap",
                        textAlign: "center",
                        verticalAlign: "middle",
                      }}
                    >
                      <Box
                        display="inline-flex"
                        alignItems="center"
                        justifyContent="center"
                        sx={{ gap: 0.5 }}
                      >
                        <strong>{displayColumns[field] || field}</strong>
                        <IconButton
                          size="small"
                          onClick={(e) => handleFilterIconClick(field, e)}
                        >
                          <FilterList fontSize="small" />
                        </IconButton>
                      </Box>

                      <Popover
                        open={Boolean(anchorEls[field])}
                        anchorEl={anchorEls[field]}
                        onClose={() => handleFilterClose(field)}
                        anchorOrigin={{
                          vertical: "bottom",
                          horizontal: "left",
                        }}
                      >
                        <Box
                          p={2}
                          display="flex"
                          flexDirection="column"
                          gap={1}
                          width={200}
                        >
                          <TextField
                            size="small"
                            fullWidth
                            placeholder={`Filter ${
                              displayColumns[field] || field
                            }`}
                            value={filters[field] || ""}
                            onChange={(e) =>
                              setFilters((prev) => ({
                                ...prev,
                                [field]: e.target.value,
                              }))
                            }
                          />
                          <Box display="flex" justifyContent="space-between">
                            <Button
                              variant="contained"
                              size="small"
                              onClick={() => handleFilterClose(field)}
                              sx={{ minWidth: 70 }}
                            >
                              Apply
                            </Button>
                            <Button
                              variant="outlined"
                              size="small"
                              onClick={() => {
                                setFilters((prev) => ({
                                  ...prev,
                                  [field]: "",
                                }));
                                handleFilterClose(field);
                              }}
                              sx={{ minWidth: 70 }}
                            >
                              Clear
                            </Button>
                          </Box>
                        </Box>
                      </Popover>
                    </TableCell>
                  ))}
                </TableRow>
              </TableHead>

              <TableBody>
                {clProject.map((row, i) => (
                  <TableRow key={i}>
                    <TableCell>
                      <Box display="flex" gap={0.5} justifyContent="center">
                        <Tooltip
                          title={
                            hasPermission("Client Projects", "Edit")
                              ? "Edit"
                              : "No permission"
                          }
                        >
                          <span>
                            <IconButton
                              size="small"
                              onClick={() =>
                                hasPermission("Client Projects", "Edit") &&
                                handleEdit(row)
                              }
                              disabled={
                                !hasPermission("Client Projects", "Edit")
                              }
                              sx={{
                                color: hasPermission("Client Projects", "Edit")
                                  ? "#2DB0E4"
                                  : "#ccc",
                              }}
                            >
                              <EditOutlinedIcon sx={{ fontSize: "16px" }} />
                            </IconButton>
                          </span>
                        </Tooltip>
                        <Tooltip
                          title={
                            hasPermission("Client Projects", "Delete")
                              ? "Delete"
                              : "No permission"
                          }
                        >
                          <span>
                            <IconButton
                              size="small"
                              onClick={() =>
                                hasPermission("Client Projects", "Delete") &&
                                handleDelete(row.cl_proj_id, row.proj_name)
                              }
                              disabled={
                                !hasPermission("Client Projects", "Delete")
                              }
                            >
                              <DeleteIcon
                                sx={{
                                  color: hasPermission(
                                    "Client Projects",
                                    "Delete"
                                  )
                                    ? "red"
                                    : "#ccc",
                                  width: 15,
                                  height: 15,
                                }}
                              />
                            </IconButton>
                          </span>
                        </Tooltip>
                        <Tooltip
                          title={
                            hasPermission("Client Projects", "Edit")
                              ? "Toggle Delete Flag"
                              : "No permission"
                          }
                        >
                          <span>
                            <IconButton
                              size="small"
                              onClick={() =>
                                hasPermission("Client Projects", "Edit") &&
                                handleToggleFlag(
                                  row.cl_proj_id,
                                  row.delete_flag
                                )
                              }
                              disabled={
                                !hasPermission("Client Projects", "Edit")
                              }
                            >
                              <Flag
                                sx={{
                                  color:
                                    row.delete_flag === "N"
                                      ? "#2E9F50"
                                      : "#FF0C0C",
                                  width: 17,
                                  height: 17,
                                  transition: "color 0.2s",
                                  verticalAlign: "middle",
                                }}
                              />
                            </IconButton>
                          </span>
                        </Tooltip>
                      </Box>
                    </TableCell>

                    {visibleColumns.map((field) => (
                      <TableCell key={field} align="left">
                        {[
                          "start_date",
                          "planned_end_date",
                          "actual_enddate",
                        ].includes(field)
                          ? row[field]
                            ? formatDateLocal(row[field])
                            : "-"
                          : field === "manager_name"
                          ? employeeNameMap[row.projectmanagerid] || "-"
                          : field === "lead_name"
                          ? employeeNameMap[row.technicalleadid] || "-"
                          : field === "HR_name"
                          ? employeeNameMap[row.hrid] || "-"
                          : row[field] || "-"}
                      </TableCell>
                    ))}
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
          <Box display="flex" justifyContent="center" mt={2}>
            <Pagination
              count={Math.ceil(totalCount / rowsPerPage)}
              page={page + 1}
              onChange={(_, newPage) => setPage(newPage - 1)}
              color="primary"
              variant="outlined"
              shape="rounded"
              sx={{
                "& .MuiPaginationItem-root": {
                  borderRadius: "8px",
                  minWidth: "32px",
                  height: "32px",
                  fontSize: "14px",
                },
                "& .Mui-selected": {
                  backgroundColor: "#b3dbea !important",
                  color: "black",
                  fontWeight: "bold",
                },
                "& .MuiPaginationItem-ellipsis": {
                  display: "none",
                },
              }}
            />
          </Box>
          <Snackbar
            open={showSnackbar}
            autoHideDuration={5000}
            onClose={() => setShowSnackbar(false)}
            anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
          >
            <Alert
              onClose={() => setShowSnackbar(false)}
              severity={snackbarSeverity} // now dynamic
              sx={{ width: "100%" }}
            >
              {snackbarMsg}
            </Alert>
          </Snackbar>
        </Box>
        <ThemeProvider theme={FormThemes}>
          <CssBaseline />
          <Dialog open={confirmOpen} onClose={() => setConfirmOpen(false)}>
            <DialogTitle>Confirm Deletion</DialogTitle>
            <DialogContent>
              {`Are you sure you want to permanently delete the project - ${projectName}?`}
            </DialogContent>
            <DialogActions>
              <Button onClick={() => setConfirmOpen(false)}>Cancel</Button>
              <Button onClick={confirmDelete} color="error" variant="contained">
                Delete
              </Button>
            </DialogActions>
          </Dialog>

          <Dialog
            open={dialogOpen}
            onClose={() => {
              setDialogOpen(false);
              setEditMode(false);
              setFormState(initialFormState);
              setFieldErrors({});
            }}
            fullWidth
            maxWidth="sm"
            sx={{
              "& .MuiDialog-paper": {
                borderRadius: 5,
                overflow: "hidden",
                width: "910px",     // increase width
                height: "55vh",
                maxWidth: "95vw",
                margin: "0 auto",
              },
            }}
          >
            <DialogTitle
              sx={{
                borderRadius: "12px",
                bgcolor: "#f5f5f5",
                p: 1,
                fontSize: "16px",
                fontWeight: 600,
                fontFamily: "Arial",
              }}
            >
              {editMode ? "Edit Project" : "Add Project"}
              <IconButton
                aria-label="close"
                onClick={() => {
                  setOpen(false);
                  setEditOpen(false);
                  setIsEditing(false);
                  setDialogOpen(false);
                  setFieldErrors({});
                }}
                sx={{ position: "absolute", right: 8, top: 5 }}
              >
                <CloseIcon />
              </IconButton>
            </DialogTitle>

            <DialogContent
              dividers
              sx={{
                p: "18px 24px",
                display: "flex",
                flexDirection: "column",
                alignItems: "stretch",
                backgroundColor: "#fff",
                mt: 0,
              }}
            >
              <Grid
                container
                rowSpacing={2}
                columnSpacing={1}
                sx={{ width: "100%", p: 1 }}
              >
                {formFields
                  .map((field, index) => (
                    <Grid item xs={12} sm={6} md={3} key={index}>
                      {renderField(
                        field,
                        formState,
                        setFormState,
                        clients,
                        managers,
                        tls,
                        hrd,
                        countries,
                        formSubmitted,
                        fieldErrors,
                        timezones
                      )}
                    </Grid>
                  ))}
              </Grid>
            </DialogContent>

            <DialogActions sx={{ p: "8px 24px", justifyContent: "flex-end" }}>
              <Button
                onClick={() => {
                  setDialogOpen(false);
                  setEditMode(false);
                  setFormState(initialFormState);
                  setFieldErrors({});
                }}
                variant="outlined"
                color="inherit"
                sx={{ mr: 1, color: "#555", borderColor: "#ccc" }}
              >
                Cancel
              </Button>

              <Button
                onClick={handleSubmit}
                variant="contained"
                color="primary"
                sx={{
                  fontWeight: "bold",
                  borderRadius: "8px",
                  px: 2.5,
                  height: 36,
                  ...(editMode
                    ? {
                        backgroundColor: "#4CAF50",
                        "&:hover": { backgroundColor: "#45a049" },
                      }
                    : {
                        backgroundColor: "#2DB0E4",
                        "&:hover": { backgroundColor: "#1D87B0" },
                      }),
                }}
              >
                {editMode ? "Update" : "Save"}
              </Button>
            </DialogActions>
          </Dialog>
        </ThemeProvider>
      </MainLayout>
    </ThemeProvider>
  );
};

export default ClientProjects;
